import tableList from '../../components/console-common/table.vue';
import editRole from '../../components/auth-manage/role-manage/edit-role.vue';
import checkAccount from '../../components/auth-manage/role-manage/check-account.vue';
import eventBus from '../../utils/fresh-table';
export default {
    components: {
        tableList: tableList,
        editRole: editRole,
        checkAccount: checkAccount,
    },
    created: function () {
        this.$store.dispatch('auth/GET_ALL_ROLES');
    },
    data: function () {
        var _this = this;
        return {
            role: {},
            showCheckBox: false,
            type: '',
            title: '',
            requestConfig: {
                url: '/proxy/auth/role/all',
                method: 'POST',
            },
            tableConfig: [
                {
                    label: '角色名称',
                    prop: 'roleName',
                    tooltip: true,
                },
                {
                    label: '账号数量',
                    prop: 'userCnt',
                    tooltip: true,
                },
                {
                    label: '创建时间',
                    prop: 'createTime',
                    tooltip: true,
                },
                {
                    label: '操作',
                    prop: 'ope_control_group',
                    width: '330px',
                    btns: [
                        {
                            name: '查看权限',
                            callback: function (row) {
                                _this.$store.dispatch('auth/CHECK_ROLE_AUTH', {
                                    roleCode: row.roleCode,
                                });
                                _this.role = {
                                    roleName: row.roleName,
                                    roleCode: row.roleCode,
                                };
                                _this.showCheckBox = false;
                                _this.type = 'check';
                                _this.title = '角色权限';
                            },
                            border: function (row) {
                                return false;
                            },
                        },
                        {
                            name: '查看账号',
                            callback: function (row) {
                                _this.$store.dispatch('auth/GET_ROLE_AUTH_ACCOUNT', {
                                    roleCode: row.roleCode,
                                });
                            },
                            border: function (row) {
                                return true;
                            },
                        },
                        {
                            name: '编辑',
                            formatter: function (val) {
                                return !val.isDefault;
                            },
                            callback: function (row) {
                                _this.$store.dispatch('auth/GET_ROLE_DETAIL', {
                                    roleCode: row.roleCode,
                                });
                                _this.role = {
                                    roleName: row.roleName,
                                    roleCode: row.roleCode,
                                };
                                _this.showCheckBox = true;
                                _this.type = 'edit';
                                _this.title = '编辑角色';
                            },
                            border: function (row) {
                                return true;
                            },
                        },
                        {
                            name: '删除',
                            callback: function (row) {
                                _this.deleteRole(row);
                            },
                            formatter: function (val) {
                                return !val.isDefault;
                            },
                            border: function (row) {
                                var btn = _this.tableConfig[_this.tableConfig.length - 1].btns;
                                return btn[2].formatter(row);
                            },
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        auth: function () {
            return this.$store.state.auth;
        },
    },
    methods: {
        addRole: function () {
            if (this.auth.allRoles && this.auth.allRoles.length >= 20) {
                this.$confirm('', '', {
                    message: '<p class="title">提示</p><p style="color:#41485D">最多只能添加20个用户角色</p>',
                    confirmButtonText: '知道了',
                    showClose: false,
                    dangerouslyUseHTMLString: true,
                    type: 'warning',
                    showCancelButton: false,
                });
                return;
            }
            this.$router.push({
                path: '/console/user-manage/user-auth/add-role',
            });
        },
        deleteRole: function (item) {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"title\">\u60A8\u786E\u8BA4\u8981\u5220\u9664\u8BE5\u89D2\u8272\u5417?</p><p style=\"color:#41485D\">\u5220\u9664\u64CD\u4F5C\u4E0D\u53EF\u9006\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF01</p>",
                dangerouslyUseHTMLString: true,
                showClose: true,
                confirmButtonText: '删除',
                type: 'warning',
                customClass: 'self-confirm delete-confirm',
            })
                .then(function () {
                _this.$request({
                    url: '/proxy/auth/role/delete',
                    method: 'post',
                    data: {
                        roleCode: item.roleCode,
                    },
                }).then(function (res) {
                    if (!res.errorCode) {
                        _this.$message('该角色已删除');
                        _this.$store.dispatch('auth/GET_ALL_ROLES');
                        eventBus.$emit('freshTable');
                    }
                    else {
                        _this.$confirm('', '', {
                            message: "<p class=\"title\">\u8BE5\u89D2\u8272\u5C1A\u6709\u7ED1\u5B9A\u8D26\u53F7\uFF0C\u65E0\u6CD5\u5220\u9664\uFF01</p><p class=\"text\">\u8BF7\u5C06\u6240\u6709\u8D26\u53F7\u89E3\u9664\u8BE5\u89D2\u8272\u540E\u518D\u5220\u9664\uFF1A\u7528\u6237\u8D26\u53F7\u7BA1\u7406-\u627E\u5230\u7ED1\u5B9A\u8D26\u53F7-\u53D6\u6D88\u52FE\u9009\u8BE5\u89D2\u8272 </p>",
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '知道了',
                            showCancelButton: false,
                            type: 'warning',
                            customClass: 'self-confirm medium-btn',
                            showClose: false,
                        });
                    }
                });
            })
                .catch(function () {
                _this.$message({
                    type: 'info',
                    message: '已取消删除',
                });
            });
        },
    },
};
